import React from 'react';
import { Divider, Flex, Text } from '@chakra-ui/react';
import { HiMiniUser } from 'react-icons/hi2';
import { BsCalendarWeekFill } from 'react-icons/bs';
import { MdAccessTimeFilled } from 'react-icons/md';
import { HiLocationMarker } from 'react-icons/hi';

const StudentDashboardEventCard = ({bagColor, bordersColor, eventName, eventAttendees, eventDate, eventTime, eventLocation}) => {

  return (
    <Flex flexDirection={'column'} gap={3} border={'1px solid'} borderColor={bordersColor} bgColor={bagColor} borderRadius={'4px'} p={5} fontFamily={'popins'}>
        <Text mb={4} color={'#0C1E33'} fontSize={'14px'} fontWeight={'600'} lineHeight={'100%'}>{eventName}</Text>
        <Divider border={'1px solid #0C1E33'} />
        <Flex gap={2} alignItems={'center'} color={'#0C1E33'}>
            <HiMiniUser style={{width: '20px', height: '20px'}} />
            <Text  fontSize={'12px'} fontWeight={'300'} lineHeight={'100%'}>{eventAttendees} Attendees</Text>
        </Flex>
        <Flex gap={2} alignItems={'center'} color={'#0C1E33'}>
            <BsCalendarWeekFill style={{width: '20px', height: '20px'}} />
            <Text  fontSize={'12px'} fontWeight={'300'} lineHeight={'100%'}>{eventDate}</Text>
        </Flex>
        <Flex gap={2} alignItems={'center'} color={'#0C1E33'}>
            <MdAccessTimeFilled style={{width: '20px', height: '20px'}} />
            <Text  fontSize={'12px'} fontWeight={'300'} lineHeight={'100%'}>{eventTime}</Text>
        </Flex>
        <Flex gap={2} alignItems={'center'} color={'#0C1E33'}>
            <HiLocationMarker style={{width: '20px', height: '20px'}} />
            <Text  fontSize={'12px'} fontWeight={'300'} lineHeight={'100%'}>{eventLocation}</Text>
        </Flex>
    </Flex>
  )
}

export default StudentDashboardEventCard